import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import { makeStyles } from "@mui/styles";
import * as React from 'react';
import Layout from '../Layout/Layout';

const useStyles = makeStyles(() => ({
    root: {
        backgroundColor: '#18042e',
        color: '#fff !important',
        '& .MuiInputBase-colorPrimary' : {
            color: '#fff !important'
        },
    },
    textArea: {
        width: 400, 
        backgroundColor: '#18042e', 

        resize: 'none', 
        border: '1px solid #e6e8f0', 
        color: '#fff', 
        borderRadius: '10px',
        fontSize: '20px' ,
        '&:focus': {
            color: '#ffff'
        }
    }

}))

export default function ContactSection() {
    const classes = useStyles();
    const handleSubmit = (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        // eslint-disable-next-line no-console
        console.log({
            name: data.get('name'),
            email: data.get('email'),
            subject: data.get('subject'),
            message: data.get('message')
        });
    };

    return (
        <Layout>
            <Container component="main" maxWidth="xs" className={classes.root}>
                <CssBaseline />
                <Box
                    sx={{
                        marginTop: 4,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="name"
                            // style={{ color: '#fff !important' }}
                            label="Name"
                            name="name"
                            autoComplete="Name"
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            label="Email Address"
                            name="email"
                            style={{ color: '#fff' }}
                            autoComplete="email"
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="subject"
                            label="Subject"
                            name="subject"
                            autoComplete="subject"
                            style={{ color: '#fff' }}
                        />
                        <TextareaAutosize
                            minRows={10}
                            aria-label="maximum height"
                            margin="normal"
                            required
                            fullWidth
                            name="message"
                            label="Message"
                            id="message"
                            autoComplete="message"
                            className={classes.textArea}
                        />
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 3, mb: 2 }}
                        >
                            Send Message
                        </Button>

                    </Box>
                </Box>
            </Container>
        </Layout>
    )
}
